/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import { Input, Spinner } from 'reactstrap';
import PropTypes from 'prop-types';

import './Autosuggest.css';

class Autosuggest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestions: {
        array: [],
        loading: false,
        show: false,
      },
      onGoingfetch: 0,
    };
  }

  handleFetch = (newValue) => {
    const { fecthSuggestions } = this.props;
    const { onGoingfetch } = this.state;
    this.setState({
      suggestions: {
        array: [],
        loading: newValue !== '',
        show: true,
      },
      onGoingfetch: onGoingfetch + 1,
    });
    if (newValue !== '') {
      setTimeout(() => {
        // eslint-disable-next-line react/destructuring-assignment
        if (this.state.onGoingfetch === onGoingfetch + 1) {
          fecthSuggestions(newValue)
            .then((suggests) => {
              // eslint-disable-next-line react/destructuring-assignment
              const newOngoingFetch = this.state.onGoingfetch;
              if (newOngoingFetch === (onGoingfetch + 1)) {
                this.setState({
                  suggestions: {
                    array: suggests,
                    loading: false,
                    show: true,
                  },
                });
              }
            });
        }
      }, 300);
    }
  };

  handleChangeValue = (newValue) => {
    const { onChange } = this.props;
    onChange(newValue);
    this.handleFetch(newValue);
  };

  handleFocus = () => {
    const { value } = this.props;
    const { suggestions } = this.state;
    if (value && value !== '') {
      this.setState({ suggestions: { ...suggestions, show: true } });
    }
  };

  handleSelectSuggestion = (id, name) => {
    const { onSelect } = this.props;
    this.setState({
      suggestions: {
        array: [],
        loading: false,
        show: false,
      },
    });
    onSelect(id, name);
  };

  handleBlur = () => {
    const { suggestions } = this.state;
    setTimeout(() => this.setState({
      suggestions: {
        ...suggestions,
        show: false,
      },
    }), 200);
  };

  render() {
    const { value, disabled } = this.props;
    const { suggestions } = this.state;
    return (
      <div className="AutocompleteText">
        <Input
          value={value}
          onChange={(e) => this.handleChangeValue(e.target.value)}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          disabled={disabled || false}
        />
        {suggestions.loading && <Spinner size="sm" style={{ position: 'relative', left: '91%', top: '-30px' }} />}
        {suggestions.array.length > 0 && suggestions.show
          && (
            <ul style={{
              position: 'absolute', width: 'calc(100% - 32px)', backgroundColor: '#FFFFFF', zIndex: '1',
            }}
            >
              {suggestions.array.map((s) => (
                <li key={s.id} onClick={() => this.handleSelectSuggestion(s.id, s.name)}>
                  {s.name}
                </li>
              ))}
            </ul>
          )}
      </div>
    );
  }
}

Autosuggest.propTypes = {
  value: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  fecthSuggestions: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

Autosuggest.defaultProps = {
  disabled: false,
};

export default Autosuggest;
